import { mix } from '@theme-ui/color';
import { PostCard } from "../../../../src/components/PostCard";
import { Tags } from "../../../../src/components/Tags";
import * as React from 'react';
export default {
  mix,
  PostCard,
  Tags,
  React
};